// ----------------------------------------------------------------------

import { pxToRem } from "@callveriq/utils/getFontValue";

export default function Tabs(theme) {
    const isLight = theme?.palette?.mode === "light";
    return {
        MuiTab: {
            styleOverrides: {
                root: {
                    fontSize: pxToRem(16),
                    "&.Mui-selected": {
                        fontWeight: "500",
                    },
                },
                textColorPrimary: {
                    fontWeight: "400",
                    color: isLight
                        ? theme?.palette?.grey?.["666"]
                        : theme?.palette?.common?.white,
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    height: "4px",
                },
                scrollButtons: {
                    "&.Mui-disabled": {
                        opacity: 0.3,
                    },
                },
            },
        },
    };
}
